import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';


@Component({
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    selector: 'support',
})
export class SupportComponent extends AppComponentBase {

    constructor(
        injector: Injector,
    ) {
        super(injector);
    }
}
